import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { FullscreenModalCloseButtonInset } from '../fullscreen/FullscreenModal/styles';

const coffeeNavBarWidth = 250;
const coffeeNavBarWidthCompact = 72;
const coffeeContentPadding = 40;
const coffeeContentPaddingCompact = 20;

export const styleSheet = StyleSheet.create({
	coffeeAppBar: {
		padding: `0 ${coffeeContentPadding}px`,
	},
	coffeeAppBarExpanded: {
		padding: `0 ${coffeeContentPaddingCompact}px`,
	},
	coffeeContainer: {
		background: '#fff',
		display: 'flex',
		height: '100%',
		minWidth: '100%',
		[THEME.queries.md]: {
			minWidth: '100%',
		},
	},
	coffeeContentContainer: {
		flex: 1,
		height: 'auto',
		minHeight: 0,
		overflowY: 'auto',
	},
	coffeeLevLogo: {
		height: 'auto',
		marginTop: 8,
		width: 'auto',
	},
	coffeeLogo: {
		height: 66,
		marginBottom: 10,
		width: 'auto',
	},
	coffeeLogoContainer: {
		alignItems: 'center',
		// boxSizing: 'border-box',
		color: '#aaa',
		display: 'flex',
		flexDirection: 'column',
		fontSize: 11,
		letterSpacing: '1.1px',
		marginBottom: 20,
		paddingTop: 20,
		textTransform: 'uppercase',
	},
	coffeeNavbar: {
		height: '100%',
		width: coffeeNavBarWidth,
	},
	coffeeNavBarCompact: {
		width: coffeeNavBarWidthCompact,
	},
	coffeeRightContainer: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		width: `calc(100% - ${coffeeNavBarWidth}px)`,
	},
	coffeeRightContainerExpanded: {
		width: `calc(100% - ${coffeeNavBarWidthCompact}px)`,
	},
	mainLogo: {
		maxHeight: 39.62,
		maxWidth: 200,
		width: '100%',
	},
	pageShell: {
		'@media (max-width: 1200px)': {
			padding: '0 1.25rem',
		},
		padding: '0 2.5rem',
	},
	pageShellCompactOnly: {
		padding: '0 1.25rem',
	},
	contentContainer: {
		flex: 1,
		height: 'auto',
		minHeight: 0,
	},
	rightContainer: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		position: 'relative',
		[THEME.queries.md]: {
			minWidth: 'calc(100% - 56px)',
			width: 'calc(100% - 56px)',
		},
	},
	rightContainerCompact: {
		minWidth: 'calc(100% - 90px)',
		width: 'calc(100% - 90px)',
	},
	warningStack: {
		display: 'flex',
		flexDirection: 'column',
		// Painted above fullscreen modals, so it has to stop short of the modal header's close button.
		// Margin, not padding: padding leaves the box full-width, so it still swallows clicks on the X.
		marginRight: FullscreenModalCloseButtonInset,
		position: 'relative',
		zIndex: 1000,
	},
});
